export default "__VITE_ASSET__cJcH0wb9__"